import { handleActions } from 'redux-actions';
import { visitLocationsSuccess } from './actions';
import { logoutSuccess } from 'ducks/auth/actions';

import initialState from './states';

export default handleActions(
  {
    [visitLocationsSuccess](state, { payload }) {
      return {
        ...state,
        list: payload,
      };
    },
    [logoutSuccess]() {
      return initialState;
    },
  },
  initialState
);
